import React from 'react';
import { KibButtonNew } from '@chewy/kib-controls-react';
import { cancelText, searchText } from './vetContent';

const VetOnboardingButtons = ({
  mobileView,
  handleCancelOnboardingVetSheet,
  handleClickAdd,
  disable,
}: {
  mobileView: boolean;
  handleCancelOnboardingVetSheet: (...args: []) => void;
  handleClickAdd: (...args: []) => void;
  disable: boolean;
}) =>
  mobileView ? (
    <div className="pet-form-vet-onboarding__buttons">
      <KibButtonNew
        className="pet-form-vet-onboarding__buttons--cancel"
        emphasis="tertiary"
        size="medium"
        data-testid="pet-form-vet-onboarding-cancelBtn"
        onClick={handleCancelOnboardingVetSheet}
      >
        {cancelText}
      </KibButtonNew>
      <KibButtonNew
        disabled={disable}
        className="pet-form-vet-onboarding__buttons--add"
        emphasis="primary"
        data-testid="pet-form-vet-onboarding-addBtn"
        size="medium"
        onClick={handleClickAdd}
      >
        {searchText}
      </KibButtonNew>
    </div>
  ) : (
    <div className="pet-form-vet-onboarding__buttons">
      <KibButtonNew
        className="pet-form-vet-onboarding__buttons--cancel"
        emphasis="tertiary"
        size="large"
        data-testid="pet-form-vet-onboarding-cancelBtn"
        onClick={handleCancelOnboardingVetSheet}
      >
        {cancelText}
      </KibButtonNew>
      <KibButtonNew
        disabled={disable}
        className="pet-form-vet-onboarding__buttons--add"
        emphasis="primary"
        data-testid="pet-form-vet-onboarding-addBtn"
        size="large"
        onClick={handleClickAdd}
      >
        {searchText}
      </KibButtonNew>
    </div>
  );

export default VetOnboardingButtons;
